import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgExpand({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.998 14.585l5.293-5.29a1 1 0 111.414 1.414l-6 5.997a.997.997 0 01-1.414 0l-6-5.997a1 1 0 011.414-1.414l5.293 5.29z"
        fill={color}
      />
    </svg>
  )
}

export default SvgExpand
